import styled from 'styled-components';
import { navBarHeight } from '../../../../utils/styles-constants';

interface LogoProps {
	isSvg: boolean;
	isDisabled?: boolean;
}

const Logo = styled('div')`
	display: flex;
	align-items: center;
	max-height: ${navBarHeight};
	max-width: 200px;

	& > img {
		max-width: 100%;
		max-height: calc(${navBarHeight} - 2px);
		cursor: ${(props: LogoProps) => props.isDisabled ? 'default' : 'pointer'};
		${(props: LogoProps) => props.isSvg ? `height: ${navBarHeight};` : ''}
	}
`;

export { Logo };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MenuManager/Header/Logo/styles.ts